export default __webpack_public_path__ + "static/media/trr-event-education.965a4c49.png";